export default class WallpaperCalculator {
	constructor() {
		this.changeMeasurement = this.changeMeasurement.bind(this);
		this.calculate = this.calculate.bind(this);
		this.addWall = this.addWall.bind(this);
		this.displayResults = this.displayResults.bind(this);
		this.removeWall = this.removeWall.bind(this);
		this.addedWallText = this.addedWallText.bind(this);
		this.resetCalculator = this.resetCalculator.bind(this);
		this.clearInputValues = this.clearInputValues.bind(this);
	}

	changeMeasurement($element, value) {
		$element.parents('.js-wallpaper-calculator').find('[data-current-measurement]').val(value);
		$element.parent().addClass('current-measurement').siblings().removeClass('current-measurement');
	}

	calculate($element) {
		let measurement = parseFloat($element.find('[data-current-measurement]').val());
		let height = parseFloat($element.find('#wallpaper-height').val());
		let $widths = $element.find('[data-wallpaper-calculator-width] input');
		let total = 0;

		$widths.each(function () {
			let width = parseFloat($(this).val());

			if (!Number.isNaN(width)) {
				total += (width / measurement) * (height / measurement) ;
			}
		});

		let totalRolls = Math.ceil(total / 4.4);

		this.displayResults($element, totalRolls);
	}

	addWall($element) {
		const $wallpaperWidth = $element.find('[data-wallpaper-calculator-width]:last-child');
		const $clonedElement = $wallpaperWidth.clone().addClass('removeable-row');
		const $rows = $element.find('[data-wallpaper-calculator-rows]');
		const widthRowsCount = $rows.find('[data-wallpaper-calculator-width]').length + 1;
		const labelText = this.addedWallText(widthRowsCount);

		// change label text
		$clonedElement.find('label').text(labelText);
		// clear value input
		$clonedElement.find('input').val('');
		$rows.append($clonedElement);
	}

	addedWallText(number) {
		let text = '';

		switch (number) {
			case 2:
				text = 'Wall Two Width:';
				break;
			case 3:
				text = 'Wall Three Width:';
				break;
			case 4:
				text = 'Wall Four Width:';
				break;
			case 5:
				text = 'Wall Five Width:';
				break;
			case 6:
				text = 'Wall Six Width:';
				break;
			default:
				text = `Wall ${number} width:`;
				break;
		}

		return text;
	}

	displayResults($element, rollsNumber) {
		const $results = $element.find('[data-wallpaper-calculator-results]');
		$results.find('small').text(rollsNumber);
		$element.removeClass('has-reset');
	}

	resetCalculator($element) {
		$element.addClass('has-reset');
	}

	removeWall($element) {
		$element.find('.removeable-row:last-child').remove();
	}

	clearInputValues($element) {
		$element.find('input[type="text"]').val('');
	}
}
